import { useState } from 'react';
import { Search } from '@customerio/pluma-components/react';

type RecipientSearchProps = {
  recipient: string | null;
  onChange: (term: string) => void;
  isDisabled?: boolean;
};

/**
 * Email-address search for the Outbox (email channel, "email" search mode).
 * Local input state committed to the filter on a debounce/clear, mirroring the
 * Ember `<delivery-recipients-suggestions-input>` behaviour (recipient
 * suggestions themselves are deferred — plain search is ported here).
 */
export function RecipientSearch({ recipient, onChange, isDisabled = false }: RecipientSearchProps) {
  const [value, setValue] = useState(recipient ?? '');
  // Keep the local input in sync when the controlled `recipient` changes out from under it
  // (Clear Filters, back/forward nav) so stale text can't linger and get re-submitted.
  const [prevRecipient, setPrevRecipient] = useState(recipient);
  if (recipient !== prevRecipient) {
    setPrevRecipient(recipient);
    setValue(recipient ?? '');
  }
  return (
    <Search
      ariaLabel="Email Address"
      placeholder="Search by email address…"
      value={value}
      onSearchInput={setValue}
      onSearch={(next) => onChange(next ?? '')}
      shouldSearchOnDebounce={500}
      shouldSearchOnClear
      isDisabled={isDisabled}
      size="sm"
    />
  );
}
